import React, { useEffect, useState } from 'react';
import { Box } from '@chakra-ui/react';
import AIAgentsTable from './components/AIAgentsTable';
import toast from 'react-hot-toast';
import { createAPIEndPoint } from 'config/api/api';
import Loader from 'loaders/Loader';
import { logoutUser } from 'utils';
import { useNavigate } from 'react-router-dom';
import { getUserData } from 'utils';

const AIAgents = () => {
  const navigate = useNavigate();
  const [assistantsData, setAssistantsData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [token, setToken] = useState(null);

  // 🔹 Step 1: On first load, handle token in URL
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tokenFromUrl = urlParams.get('token');

    if (tokenFromUrl) {
      // Clear everything from localStorage
      localStorage.clear();

      // Set new access token
      localStorage.setItem('access_token', tokenFromUrl);
      setToken(tokenFromUrl);

      console.log('Token found in URL and localStorage cleared');
    }
  }, []);

  // 🔹 Step 2: Hit auth_profile API if token is present
  const checkAuthProfile = async () => {
    try {
      const response = await createAPIEndPoint('auth_profile').fetchAll();
      const data = response.data;

      // Save user profile and role in localStorage
      localStorage.setItem('user_profile', JSON.stringify(data.profile));
      localStorage.setItem('user_role', JSON.stringify(data.profile.user_role));

      console.log(
        ' checkAuthProfile ~ data.profile.user_role:',
        data.profile.user_role,
      );

      navigate(
        data.profile.user_role === 'admin' ? '/admin/team' : '/admin/ai-agents',
        { replace: true },
      );

      console.log('✅ Auth Profile fetched');
      return { success: true };
    } catch (error) {
      const errorMsg = error?.response?.data?.error || 'Auth error';
      console.error('Auth error:', errorMsg);

      if (errorMsg.includes('Invalid Bearer token')) {
        toast.error('Unauthorized access. Please log in.');
        logoutUser(navigate);
      }
      return { success: false };
    }
  };

  const fetchAssistants = async () => {
    setLoading(true);
    try {
      const response = await createAPIEndPoint(`list_assistants`).fetchAll();
      setAssistantsData(response.data || []);
    } catch (err) {
      toast.error(err?.response?.data?.error || 'Error fetching assistants');
      if (err?.response?.data?.error?.includes('Bearer token')) {
        logoutUser(navigate);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const init = async () => {
      if (token) {
        const authResult = await checkAuthProfile();
        if (authResult.success) {
          fetchAssistants();
        }
      } else {
        // No token in URL — regular load
        fetchAssistants();
      }
    };

    init();
  }, [token]);

  return (
    <Box pt={{ base: '80px', md: '80px', xl: '80px' }}>
      {loading && <Loader />}
      <AIAgentsTable
        tableData={assistantsData}
        loading={loading}
        fetchAgain={fetchAssistants}
      />
    </Box>
  );
};

export default AIAgents;
